export default {
  helperText: 'Parametry zasobów definiują właściwości zasobu – takie jak progi, wartości domyślne lub cechy fizyczne. Każdy parametr należy do przestrzeni nazw, kategorii i ma nazwę (np. "klimat", "limity", "temperatura maksymalna"). Parametry mogą być jawnie zdefiniowane dla zasobu lub dziedziczone z zasobu nadrzędnego. Jeśli w hierarchii nie zostanie znaleziona żadna wartość, zostanie użyta wartość domyślna',

};
